import ListView, { ListViewItem } from '@ingka/list-view';
import board from '@ingka/ssr-icon/paths/board';
import box from '@ingka/ssr-icon/paths/box';
import creditCard from '@ingka/ssr-icon/paths/credit-card';
import deliveryTruck from '@ingka/ssr-icon/paths/delivery-truck';
import discountTag from '@ingka/ssr-icon/paths/discount-tag';
import documentPencil from '@ingka/ssr-icon/paths/document-pencil';
import home from '@ingka/ssr-icon/paths/home';
import lock from '@ingka/ssr-icon/paths/lock';
import pencil from '@ingka/ssr-icon/paths/pencil';
import person from '@ingka/ssr-icon/paths/person';
import points from '@ingka/ssr-icon/paths/reward';
import trashCan from '@ingka/ssr-icon/paths/trash-can';
import Text from '@ingka/text';
import { useTranslation } from 'react-i18next';

import { PREFIX } from '../../../Skapa/constants/constants';
import InlineMessage from '../../../Skapa/InlineMessage/InlineMessage';
import { LogoutButton } from '../LogoutButton/LogoutButton';
import { LoyaltyButton } from '../LoyaltyCard/LoyaltyButton';
import { MenuData, LoyaltyCard, MenuLinkInfo } from '../menu-types';

import styles from './Menu.module.scss';

function iconTypeToIcon(icon: MenuLinkInfo['icon']) {
  switch (icon) {
    case 'board':
      return board;
    case 'document-pencil':
      return documentPencil;
    case 'discount-tag':
      return discountTag; // voucher tag
    case 'box':
      return box;
    case 'delivery-truck':
      return deliveryTruck;
    case 'home':
      return home;
    case 'credit-card':
      return creditCard;
    case 'lock':
      return lock;
    case 'pencil':
      return pencil;
    case 'person':
      return person;
    case 'points':
      return points;
    case 'trash-can':
      return trashCan;
    default:
      console.warn('missing icon for icon name: ', icon);
      return undefined;
  }
}

const Child = ({ model }: { model: MenuLinkInfo }) => (
  <ListViewItem
    emphasised
    inset
    key={model.title}
    prefix={PREFIX}
    title={model.title}
    description={model.subtitle}
    control="link"
    leadingIcon={iconTypeToIcon(model.icon)}
    href={model.href}
    controlIcon="chevronRightSmall"
    className={styles.listViewItem}
  />
);

export function MenuLoggedIn({
  menu,
  logout,
  logoutError,
  onLoyaltyCardClick,
}: Readonly<{
  menu: MenuData;
  logoutError?: boolean;
  onLoyaltyCardClick: (card: LoyaltyCard) => void;
  logout: () => void;
}>) {
  const { t } = useTranslation('profile');
  return (
    <div className={styles.wrapper}>
      <div className={styles.headingArea}>
        <Text
          prefix={PREFIX}
          tagName="h1"
          textStyle="Heading.M"
          className={styles.heading}
          data-testid="logged-in-sheet-header"
        >
          {menu.greeting}
        </Text>
        {menu.loyaltyCard ? <LoyaltyButton loyaltyCard={menu.loyaltyCard} onClick={onLoyaltyCardClick} /> : null}
      </div>

      <nav>
        <ListView
          id="main-page-navigation"
          prefix={PREFIX}
          size="medium"
          className={styles.listView}
          showDivider={false}
        >
          {menu.links.map((x) => (
            <Child key={x.title} model={x} />
          ))}
        </ListView>

        {logoutError && (
          <InlineMessage
            variant="negative"
            title={t('errorBoundary.title')}
            body={t('pageError.genericIsOnlineMessage')}
          />
        )}

        <LogoutButton logout={logout} />
      </nav>
    </div>
  );
}
